import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";

const Edit = (props) => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const { id } = useParams();
  const [error, setError] = useState({});
  const [chartOfAccount, setChartOfAccount] = useState([]);
  const [department, setDepartment] = useState({});
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [journalCode, setJournalCode] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [isRequired, setIsRequired] = useState(false);
  const [list, setList] = useState([{ dr_accounts: "", cost_center: "" }]);
  const [loading, setLoading] = useState(false);
  const { checkRequiredFields } = useRequiredFields();

  const array = ["1", "2", "3", "4", "5", "6", "12"];
  const idExists = array.includes(id);

  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        const transactionsListRes = await Http.get(
          "/transactions-list-connect/" + id + "/edit"
        );
        setInputs({
          cr_chart_of_account:
            transactionsListRes.data.info.cost_center_wise_cr_account.id,
          acc_journal_code_id:
            transactionsListRes.data.info.transaction_code[0]
              .acc_journal_code_id,
          acc_subcategory_ledger_id:
            transactionsListRes.data.info.transaction_code[0]
              .acc_subcategory_ledger_id,
        });

        const listInfo = [];
        Object.keys(transactionsListRes.data.lists).forEach((key) => {
          const { dr_chart_of_account_id, department } =
            transactionsListRes.data.lists[key];
          const costCenters = department.map((dept) => ({
            label: dept.department_name,
            value: dept.department_id,
          }));
          listInfo.push({
            dr_accounts: dr_chart_of_account_id,
            cost_center: costCenters,
          });
        });

        setList(listInfo);

        const chartOfAccountRes = await Http.get("/chart-of-account-code");
        const options = chartOfAccountRes.data.chart_of_accounts.map(
          (item) => ({
            value: item.id,
            label: `${item.code} - ${item.name}`,
          })
        );
        setChartOfAccount(options);

        const departmentRes = await Http.get("/department3");
        setDepartment(departmentRes.data);

        const journalCodeRes = await Http.get("/journal-code");
        const journalOptions = journalCodeRes.data.map((item) => ({
          value: item.id,
          label: `${item.code} - ${item.name}`,
        }));
        setJournalCode(journalOptions);

        const subCategoryRes = await Http.get("/sub-category");
        const subCategoryOptions = subCategoryRes.data.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setSubCategory(subCategoryOptions);
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const selectHandleChange = (selectedValues) => {
    setChartOfAccount(selectedValues);
  };

  const handleListChange = (index, selectedValues) => {
    const updatedList = [...list];
    updatedList[index].cost_center = selectedValues;
    setList(updatedList);
  };

  const handleCOAChange = (selectedOption, index) => {
    const inputInfo = [...list];
    inputInfo[index]["dr_accounts"] = selectedOption?.value || "";
    setList(inputInfo);
  };

  const handleCrAccountChange = (selectedOption) => {
    setInputs((prevInputs) => ({
      ...prevInputs,
      cr_chart_of_account: selectedOption?.value || "",
    }));
  };

  const handleJournalCodeChange = (selectedOption) => {
    setInputs((prevInputs) => ({
      ...prevInputs,
      acc_journal_code_id: selectedOption?.value || "",
    }));
  };

  const handleSubCategoryChange = (selectedOption) => {
    setInputs((prevInputs) => ({
      ...prevInputs,
      acc_subcategory_ledger_id: selectedOption?.value || "",
    }));
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  // Add More List
  const addMoreList = () => {
    setList([...list, { dr_accounts: "", cost_center: "" }]);
  };

  // Remove List
  const removeList = (index) => {
    const inputInfo = [...list];
    inputInfo.splice(index, 1);
    setList(inputInfo);
  };

  const formSubmit = () => {
    inputs.list = list;

    console.log("Submitted inputs:", inputs);

    Http.put("/transactions-list-connect/" + id, inputs)
      .then((res) => {
        navigate("/transactions-list-connect", {
          state: { message: res.data.message, type: res.data.type },
        });
      })
      .catch(function (e) {
        const errorData = e?.response?.data;

        if (errorData?.errors) {
          setError(errorData.errors); // expected Laravel validation errors
        } else if (errorData?.message) {
          setError({ general: [errorData.message] }); // general error message
        } else {
          setError({ general: ["Something went wrong. Please try again."] });
        }
      });
  };

  return (
    <div>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Transaction Connect</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">
              Edit Transaction Connect
            </h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                {Array.from(list).map((x, i) => (
                  <div className="row mb-3" key={i}>
                    <div className="col-lg-5">
                      {idExists ? (
                        <label htmlFor="">Dr Account:</label>
                      ) : (
                        <label htmlFor="">Cr Account:</label>
                      )}
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        name="dr_accounts"
                        options={chartOfAccount}
                        onChange={(selectedOption) =>
                          handleCOAChange(selectedOption, i)
                        }
                        value={
                          chartOfAccount.find(
                            (opt) => opt.value === parseInt(x.dr_accounts)
                          ) || null
                        }
                      />
                    </div>
                    <div className="col-lg-5">
                      <label htmlFor="">Cost Center:</label>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        name="cost_center"
                        options={department}
                        placeholder="Please select cost center."
                        isMulti={true}
                        value={x.cost_center}
                        onChange={(selectedValues) =>
                          handleListChange(i, selectedValues)
                        }
                        {...(isRequired && {
                          styles: {
                            control: (base, { menuIsOpen, hasValue }) => {
                              const borderColor = hasValue
                                ? "#ccc"
                                : menuIsOpen
                                ? "#ccc"
                                : "red";
                              return { ...base, borderColor };
                            },
                          },
                        })}
                      />
                    </div>
                    <div className="col-lg-2">
                      {list.length > 1 ? (
                        <button
                          className="btn btn-danger btn-block"
                          onClick={() => removeList(i)}
                          style={{ marginTop: "1.8rem" }}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ))}

                <div className="row mt-3">
                  <div className="col-10"></div>
                  <div className="col-2">
                    <button
                      className="btn btn-info btn-block mg-b-10"
                      onClick={addMoreList}
                    >
                      <i className="fa fa-plus mg-r-10"></i> ADD More
                    </button>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-12 mb-3">
                    {idExists ? (
                      <label htmlFor="">Cr Account:</label>
                    ) : (
                      <label htmlFor="">Dr Account:</label>
                    )}

                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      name="cr_chart_of_account"
                      options={chartOfAccount}
                      onChange={(selectedOption) =>
                        handleCrAccountChange(selectedOption)
                      }
                      value={
                        chartOfAccount.find(
                          (opt) => opt.value === inputs.cr_chart_of_account
                        ) || null
                      }
                    />
                  </div>
                  <div className="col-lg-12 mb-3">
                    <label htmlFor="">Journal Code:</label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      name="acc_journal_code_id"
                      options={journalCode}
                      onChange={(selectedOption) =>
                        handleJournalCodeChange(selectedOption)
                      }
                      value={
                        journalCode.find(
                          (opt) =>
                            opt.value === parseInt(inputs.acc_journal_code_id)
                        ) || null
                      }
                    />
                  </div>
                  <div className="col-lg-12">
                    <label htmlFor="">Subcategory Journal :</label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      name="acc_subcategory_ledger_id"
                      options={subCategory}
                      onChange={(selectedOption) =>
                        handleSubCategoryChange(selectedOption)
                      }
                      value={
                        subCategory.find(
                          (opt) =>
                            opt.value ===
                            parseInt(inputs.acc_subcategory_ledger_id)
                        ) || null
                      }
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Update
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default Edit;
